import api from "./api";

class StatsService {
    getStatsByEventId(eventId) {
        return api.get(`/event/${eventId}/stats`);
    };

    getCreditPurchasesStats(params) {
        return api.post("/account/credit/purchases/stats", params);
    };

    getCreditConsumptionsStats(params) {
        return api.post("/account/credit/consumption/stats", params);
    };

    getCreditStats(params) {
        return api.post("/account/credit/stats", params);
    };

    getNumberOfDeliveredPhotos(eventId) {
        return api.get("/event/" + eventId + "/delivered-photos");
    };

    getNumberOfIndexedFaces(eventId) {
        return api.get("/event/" + eventId + "/indexes-faces");
    };

    getNumberOfPhotos(eventId) {
        return api.get("/event/" + eventId + "/number-photos");
    };

    getNumberOfSelfies(eventId) {
        return api.get("/event/" + eventId + "/number-selfies");
    };

    getNumberOfUsersAccessByCode(eventId) {
        return api.get("/event/" + eventId + "/users-access");
    };

    getNumberOfUsersWithMatch(eventId) {
        return api.get("/event/" + eventId + "/users-match");
    };

    getNumberOfUniquesSharesByEvent(eventId) {
        return api.get("/event/" + eventId + "/shared-count");
    };

    getNumberOfUniquesViewsByEvent(eventId) {
        return api.get("/event/" + eventId + "/shared-views-count");
    };

    getNumberOfGlobalViewsByEvent(eventId) {
        return api.get("/event/" + eventId + "/all-views-count");
    }

    getPhotosByUser(eventId) {
        return api.get("/event/" + eventId + "/photos-by-user");
    }

    getOrdersAmount(eventId) {
        return api.get("/event/" + eventId + "/orders-amount");
    }

    getSoldPhotos(eventId) {
        return api.get("/event/" + eventId + "/sold-photos");
    }

    getSoldPacksAmount(eventId) {
        return api.get("/event/" + eventId + "/sold-packs-amount");
    }

    getNumberOfOrders(eventId) {
        return api.get("/event/" + eventId + "/number-orders");
    }

    getNumberOfPackOrders(eventId) {
        return api.get("/event/" + eventId + "/number-pack-orders");
    }

    getTotalAmountOrders(eventId) {
        return api.get("/event/" + eventId + "/total-amount-orders");
    }

    getTotalAmountPackOrders(eventId) {
        return api.get("/event/" + eventId + "/total-amount-pack-orders");
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new StatsService();